import { RegionId } from "@sp-crm/core";
import { useQuery } from "@tanstack/react-query";
import { trpc } from "components/rpc/trpc";
import { stableQueryOptionsRpc } from "util/requests";

export const useOfficeTaskTypeState = (regionId: RegionId | null) => {
    const trpcClient = trpc.useTRPC();
    return useQuery({
        ...trpcClient.taskType.officeTaskTypeState.queryOptions({
            regionId: regionId ?? ("" as RegionId),
        }),
        ...stableQueryOptionsRpc(),
        enabled: !!regionId,
    });
};
